export default __webpack_public_path__ + "static/media/CARE_ICON_LOADING_.b3831844.gif";